import React, { useEffect, useState } from 'react';
import { ImageBackground, View, StyleSheet, Platform, Linking } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import { replaceAction } from '../../../helpers/navigationHelpers';
import getPlatformType, { getImage } from '../../../helpers/getPlatform';
import BackGroundGenerator from '../../LandingPages/common/BackGroundGenerator';
import ODSButton from '../../../../openbrix-design-system/ui/atoms/ODSButton';
import RentReviewTabs from '../../../../openbrix-design-system/ui/molecules/RentReviewTabs';
import { tenantActions } from '../openFlowRedux/tenant.actions';
import { TenantService } from '../openFlowRedux/tenant.service';
import { showToaster } from '../../../redux/actions/toast';
import Loader from '../../../commonComponents/activityIndicator/activityIndicator';

const RentReviewScreen = (props) => {
  const dispatch = useDispatch();
  const layoutType = getPlatformType();
  const isWeb = layoutType === 'web';
  const flowId = props?.route?.params?.id;

  const rentReviewData = useSelector((state) => state?.tenant?.rentReviewData);
  const rentReviewLoading = useSelector((state) => state?.tenant?.rentReviewLoading);
  const userId = useSelector((state) => state.authReducer?.profile?.data?.appUser?.app_user_id);
  const [downloading, setDownloading] = useState(false);

  const alertActions = {
    error: (msg) => dispatch(showToaster('error', msg)),
    success: (msg) => dispatch(showToaster('', msg)),
  };

  useEffect(() => {
    if (flowId) {
      dispatch(tenantActions.getRentReview(flowId));
    }
  }, [flowId, dispatch]);

  const handleBackToTenancy = () => {
    replaceAction(props?.navigation, 'My Tenancy', { id: flowId });
  };

  const handleRejectOffer = () => {
    if (flowId) {
      dispatch(tenantActions.respondRentReview(flowId, { response: 'rejected' }));
    }
  };

  const handleSignAgreement = () => {
    // E-sign is handled directly by opening Yoti signature URL in RentReviewTabs
  };

  const handleDownloadDoc = async (doc) => {
    if (doc?.id === 'signed_agreement') {
      try {
        setDownloading(true);
        const rentReviewId =
          doc.rentReviewId ||
          rentReviewData?.data?.active?.open_flow_rent_review_id ||
          rentReviewData?.data?.active?.id ||
          rentReviewData?.active?.open_flow_rent_review_id ||
          rentReviewData?.active?.id;

        if (!rentReviewId) {
          alertActions.error('Could not identify rent review for download');
          setDownloading(false);
          return;
        }

        const response = await TenantService.downloadSignedRentReviewAgreement(rentReviewId);
        if (!response || !response.ok) {
          alertActions.error('Unable to download signed agreement. Please try again.');
          setDownloading(false);
          return;
        }

        const blob = await response.blob();
        const fileName = `Signed_Rent_Review_Agreement_${rentReviewId}.zip`;

        if (Platform.OS === 'web') {
          saveAs(blob, fileName);
        } else {
          // Mobile platform handling (Native file sharing / storage)
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = async () => {
            const base64data = reader.result;
            saveAs(blob, fileName);
          };
        }
      } catch (err) {
        alertActions.error('Error downloading document');
      } finally {
        setDownloading(false);
      }
    } else if (doc?.url) {
      if (Platform.OS === 'web') {
        window.open(doc.url, '_blank', 'noreferrer');
      } else {
        Linking.openURL(doc.url);
      }
    }
  };

  return (
    <BackGroundGenerator isTLYF props={props}>
      <Loader loading={downloading} />
      <ImageBackground
        source={getImage('openflow.png')}
        style={styles.headerBackground}
        resizeMode="cover"
      >
        <ODSButton
          rIcon="TB-Arrow-Left"
          restStyle={styles.backButton}
          type="secondary"
          disabled={false}
          onPress={handleBackToTenancy}
        >
          Completed Move In
        </ODSButton>
      </ImageBackground>

      <View style={[styles.container, isWeb ? styles.webContainer : styles.mobileContainer]}>
        <RentReviewTabs
          loading={rentReviewLoading}
          rentReviewData={rentReviewData}
          userId={userId}
          onRejectOffer={handleRejectOffer}
          onSignAgreement={handleSignAgreement}
          onDownloadDoc={handleDownloadDoc}
          onContactAgent={handleBackToTenancy}
        />
      </View>
    </BackGroundGenerator>
  );
};

/* ─── Styles ─── */
const styles = StyleSheet.create({
  headerBackground: {
    width: '100%',
    height: 260,
    paddingTop: 20,
    paddingLeft: 20,
  },
  backButton: {
    alignSelf: 'flex-start',
    marginTop: 20,
    marginLeft: 20,
  },
  container: {
    alignSelf: 'center',
    marginTop: -100,
    marginBottom: 60,
    paddingHorizontal: 16,
    width: '100%',
  },
  webContainer: {
    maxWidth: 680,
  },
  mobileContainer: {
    maxWidth: '95%',
  },
});

export default RentReviewScreen;

